export const EXPORT_FULFILLMENT_REQUEST = 'EXPORT_FULFILLMENT_REQUEST';
export const exportFulfillments = (fulfillmentIds, filters) => ({
  type: EXPORT_FULFILLMENT_REQUEST,
  fulfillmentIds,
  filters,
});

export const EXPORT_FULFILLMENTS_REQUEST_EXTENDED = 'EXPORT_FULFILLMENTS_REQUEST_EXTENDED';
export const exportFulfillmentsRequestExtended = (
  viewRecordsOrSelectedRecords,
  primaryRecordsOrLineItems,
  selectedFulfillmentIds,
  orderByColumn,
  orderByDirection,
  columnConfiguration,
  searchTerm,
  intl,
  filters,
) => ({
  type: EXPORT_FULFILLMENTS_REQUEST_EXTENDED,
  viewRecordsOrSelectedRecords,
  primaryRecordsOrLineItems,
  selectedFulfillmentIds,
  orderByColumn,
  orderByDirection,
  columnConfiguration,
  searchTerm,
  intl,
  filters,
});

export const CUSTOM_EXPORT_FULFILLMENTS_REQUEST = 'CUSTOM_EXPORT_FULFILLMENTS_REQUEST';
export const customExportFulfillmentsRequest = (
  viewRecordsOrSelectedRecords,
  extractId,
  selectedFulfillmentIds,
  orderByColumn,
  orderByDirection,
  searchTerm,
  filters,
) => ({
  type: CUSTOM_EXPORT_FULFILLMENTS_REQUEST,
  viewRecordsOrSelectedRecords,
  extractId,
  selectedFulfillmentIds,
  orderByColumn,
  orderByDirection,
  searchTerm,
  filters,
});
